module.exports = __webpack_public_path__ + "img/project_end.png";